<template>
    <div :class="{
            'rv-profile-update position-relative':true,
            'rv-profile-update-mobile': $detect == 'mobile'
        }">
        <div :class="{
                'profile-expired bg-white': true,
                'mb-3 px-3 py-10px': $detect == 'web',
                'p-3': $detect == 'mobile'
            }" v-if="this.data.status == 1 && this.data.status_expire === 0">
            <span class="mb-0 fs-14px text-danger">Tin rao của bạn đã hết hạn. Vui lòng gia hạn để tiếp tục sử dụng</span>
            <!-- <button class="btn btn-danger btn-sm ml-3 px-4" @click="availability()">Gia hạn ngay</button> -->
        </div>
        <updateWeb
            :data="data"/>
       
    </div>
</template>
<script>
// import { availability } from '@/config/raovat';
export default {
    components: {
        updateWeb: () => import('@/components/profile/product/update/updateWeb')
    },
    data() {
        return {
            content: '',
            loading: false,
            id: this.$route.params.id,
            data: {},
        }
    },
    created() {
      
        // apiGet(`/v2/profile/products/${this.id}`).then(res => {
        //    console.log(res)
            
        // }).catch(err => {
        //      this.$message({
        //         message: 'Lỗi hệ thống',
        //         type: 'error',
        //         center: true,
        //     });
        // })
          apiGet(`/v2/profile/products/${this.id}`).then(res => {
           this.data = res.data
        }).catch(err => {
            this.$message({
                message: 'Sản phẩm không tồn tại!',
                type: 'error',
                center: true,
            });
        })
    },
    methods: {
        sortImg(image, image_main){
            let img = [];
            image.map(item => {
                if(item.name === image_main){
                    img.unshift(item);
                }else{
                    img.push(item);
                }
            })
            return img;
        },
        async availability(){
            if(await availability(this.id, this)){
                this.data.status_expire = 1;
            }
        }
    }
}
</script>
<style lang="scss">
    .rv-profile-update {
        box-shadow: none !important;
        background: transparent !important;
        padding: 0 !important;
        border-radius: 0 !important;
    }
    .rv-profile-update-mobile {
        margin: -8px;
    }
    .profile-expired {
        box-shadow: 0 4px 25px 0 rgba(0, 0, 0, 0.1);
        border-radius: 5px;
    }
</style>
